




































import { Component, Vue } from "vue-property-decorator";

@Component
/**
 * Called before redirecting user to an external url
 */
export default class ExternalLink extends Vue {
  /**
   * redirect to external page
   * @param event
   */
  openExternalLink(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.externalUrl) {
      window.location.replace(this.externalUrl);
    }
  }

  /**
   * close the current tab
   */
  closeTab(): void {
    close();
  }

  /**
   * get the validated url
   */
  get externalUrl(): string | null {
    const destinationUrl = this.$route.query["destination"].toString();
    if (destinationUrl) {
      if (this.validURL(destinationUrl)) {
        return destinationUrl;
      }
    }
    return null;
  }

  /**
   * validate the url
   * https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
   * @param urlCandidate
   */
  validURL(urlCandidate: string): boolean {
    const urlRegex = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!urlRegex.test(urlCandidate);
  }
}
